import React from 'react';
import PrivateRoute from '../../components/common/PrivateRoute';
import { Switch, Route } from 'react-router-dom';
import PageError from "../../components/layout/PageError";
import Dashboard from "../../pages/authorized/Dashboard";
import Access from "../../pages/authorized/Access";
import CompanyDetail from "../../pages/authorized/CompanyDetail";
import User from "../../pages/authorized/User";
import UserDetail from "../../pages/authorized/UserDetail";
import Scheme from "../../pages/authorized/Scheme";
import SchemeDetail from "../../pages/authorized/SchemeDetail";
import SchemeApplication from "../../pages/authorized/SchemeApplication";
import SchemeApplicationDetail from "../../pages/authorized/SchemeApplicationDetail";
import InputDelivery from "../../pages/authorized/InputDelivery";
import InputDeliveryDetail from "../../pages/authorized/InputDeliveryDetail";
import PreSeasonContract from "../../pages/authorized/PreSeasonContract";
import PreSeasonContractDetail from "../../pages/authorized/PreSeasonContractDetail";
import TradeOffer from "../../pages/authorized/TradeOffer";
import TradeOfferDetail from "../../pages/authorized/TradeOfferDetail";
import SellRequest from "../../pages/authorized/SellRequest";
import SellRequestDetail from "../../pages/authorized/SellRequestDetail";
import Product from "../../pages/authorized/Product";
import ProductDetail from "../../pages/authorized/ProductDetail";
import Activity from "../../pages/authorized/Activity";
import Support from "../../pages/authorized/Support";

const Private = () => {
    return (
        <div>
            <Switch>
                <PrivateRoute exact path="/dashboard" component={Dashboard} />
                <PrivateRoute exact path="/company/:id" component={CompanyDetail} />
                <PrivateRoute exact path="/user" component={User} />
                <PrivateRoute exact path="/user/:id" component={UserDetail} />
                <PrivateRoute exact path="/access" component={Access} />
                <PrivateRoute exact path="/scheme" component={Scheme} />
                <PrivateRoute exact path="/scheme/:id" component={SchemeDetail} />
                <PrivateRoute exact path="/scheme_application" component={SchemeApplication} />
                <PrivateRoute exact path="/scheme_application/:id" component={SchemeApplicationDetail} />
                <PrivateRoute exact path="/input_delivery" component={InputDelivery} />
                <PrivateRoute exact path="/input_delivery/:id" component={InputDeliveryDetail} />
                <PrivateRoute exact path="/preseason_contract" component={PreSeasonContract} />
                <PrivateRoute exact path="/preseason_contract/:id" component={PreSeasonContractDetail} />
                <PrivateRoute exact path="/trade_offer" component={TradeOffer} />
                <PrivateRoute exact path="/trade_offer/:id" component={TradeOfferDetail} />
                <PrivateRoute exact path="/sell_request" component={SellRequest} />
                <PrivateRoute exact path="/sell_request/:id" component={SellRequestDetail} />
                <PrivateRoute exact path="/product" component={Product} />
                <PrivateRoute exact path="/product/:id" component={ProductDetail} />
                <PrivateRoute exact path="/activity" component={Activity} />
                <PrivateRoute exact path="/support" component={Support} />
                <PrivateRoute exact path="/error" component={PageError} />
                <Route component={PageError} />
            </Switch>
        </div>
    );
};

export default Private;
